<template>
  <OpenDownIcon :class="clsx('popup-toggle', { 'popup-toggle--open': isOpen })" :color="calculateTogglerColor" />
</template>

<script>
import clsx from 'clsx';
import { OpenDownIcon } from '@/shared/ui/icons';

export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
      required: false,
    },
  },
  components: { OpenDownIcon },
  computed: {
    calculateTogglerColor() {
      if (this.color && this.color !== '') {
        return this.color;
      }

      if (this.isDisabled) {
        return '#6B7280';
      }

      return this.isActive ? '#FB923C' : '#09090B';
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.popup-toggle {
  transition: transform 0.2s;

  &--open {
    transform: rotate(180deg);
  }
}
</style>
